export function isEmptyObject(obj){
  if(obj === undefined || obj === null)  {
    return true;
  }
  return !Object.keys(obj).length;
}

export function isNullOrEmpty(obj){
  return obj === undefined || obj === null ||  !Object.keys(obj).length;
}

/**
 * HtmlElementをkey毎に格納する
 */
export function convertToKeyMapElements(keyElements) {
  if(keyElements) {
    let mapElements = {};
    for (let element of keyElements) {
      if (element.key) {
        mapElements[element.key] = element;
      }
    }
    return mapElements;
  } else {
    return null;
  }
}

export function isEmptyList(list) {
  return list === null || list === undefined || list.length === 0;
}



/**
 * is for boolean
 * @param bool_value
 * @returns {boolean}
 */
export function isBool(bool_value) {
  if(bool_value === "true" || bool_value === "True" || bool_value === true) {
    return true;
  } else if(bool_value === "false" || bool_value === "False" || bool_value === false) {
    return false;
  } else {
    return false;
  }
}